import {
  Banknote,
  Building2,
  LineChart,
  LayoutDashboard,
  ScanFace,
  TrendingDown,
  TrendingUp,
  UserCheck,
  ArrowLeftRight,
  History,
  Gift,
  Share2,
  Users,
  Trophy,
  MessagesSquare,
  Bot,
  Sparkles,
  Award,
  UserCog,
  Settings,
  PieChart,
  PiggyBank,
  type LucideIcon,
} from "lucide-react";

export interface TraderNavItem {
  label: string;
  to: string;
  icon: LucideIcon;
  /** Optional badge text shown on the right (e.g. status count). */
  badge?: string;
}

/**
 * Trader sidebar — mirrors the standard user-side sections
 * (1–20). Unfinished routes fall through to a stub page until the
 * feature ships.
 */
export const traderNav: TraderNavItem[] = [
  { label: "Dashboard", to: "/trader/dashboard", icon: LayoutDashboard },
  { label: "My Profile", to: "/trader/profile", icon: UserCog },
  { label: "Banks", to: "/trader/banks", icon: Building2 },
  { label: "Trade Accounts", to: "/trader/accounts", icon: Banknote },
  { label: "Web Trader", to: "/trader/web-trader", icon: LineChart },
  { label: "Trade History", to: "/trader/history", icon: History },
  { label: "Portfolio Analysis", to: "/trader/portfolio-analysis", icon: PieChart },
  { label: "Account Settings", to: "/trader/account-settings", icon: Settings },
  { label: "Deposit Funds", to: "/trader/deposit", icon: TrendingUp },
  { label: "Withdraw Funds", to: "/trader/withdraw", icon: TrendingDown },
  { label: "Fund Transfer", to: "/trader/fund-transfer", icon: ArrowLeftRight },
  { label: "Copy Trading", to: "/trader/copy-trading", icon: Share2 },
  { label: "PAMM / MAM", to: "/trader/funds", icon: Award },
  { label: "Funded Challenge", to: "/trader/funded-challenge", icon: Trophy },
  { label: "Investments", to: "/trader/investments", icon: PiggyBank },
  { label: "Bonus & Loyalty", to: "/trader/bonus", icon: Gift },
  { label: "Trade & Win", to: "/trader/rewards", icon: Award },
  { label: "Trading Contest", to: "/trader/contest", icon: Trophy },
  { label: "Ranks & Coins", to: "/trader/gamification", icon: Sparkles },
  { label: "Expert Advisors", to: "/trader/ea", icon: Bot },
  { label: "Become an IB", to: "/trader/become-ib", icon: UserCheck },
  { label: "KYC Verification", to: "/trader/kyc", icon: ScanFace },
  { label: "Support Tickets", to: "/trader/support", icon: MessagesSquare },
];
